import React from 'react'
import { FiChevronDown, FiChevronLeft, FiClock } from 'react-icons/fi'
import { BiCoffeeTogo } from 'react-icons/bi'
import { IoMdFingerPrint } from 'react-icons/io'
import { SiTypescript, SiBootstrap, SiRedux, SiFramer } from 'react-icons/si'
import { FaSass } from 'react-icons/fa'
import { MdOutlineDarkMode } from 'react-icons/md'
import Navbar from '../../@shared/navigations/default'

const FaqPage = () => {
    return (
       <React.Fragment>
        <title>Frequently Asked Questions</title>
        <Navbar /> 
         <div id="faq">
          <Banner title='Frequently asked questions' />
           <Accordions  d />
           <Supports data={featuresFaq} />
        </div>
       </React.Fragment>
    )
}

export default FaqPage
 
const Banner = ({title}) => (
    <div id="faq">
        <div className="banner">
            <h1 className='title'>{title}</h1>
        </div>
    </div>
)


const Supports = ({data=faq}) => {

    return (
        <div className='supports'>
            <ul>
                {
                    data.map((item,i)=>(
                        <li key={`support-${i}`}>
                            <div className="circle">{item.symbol}</div>
                            <h3 className="title">{item.title}</h3>
                            <p>{item.description}</p>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}


export const faq = [
    {title:'Fast',  path:'#',symbol:<FiClock /> , description:'Fastest template built with React and powered by NextJS. Build your amazing React App with NOVA.'}, 
    {title:'Easy to use', path:'#',symbol:<BiCoffeeTogo />, description:'Easy to use with advanced and rich components. High customization & hybrid features adaptable for different environments.'}, 
    {title:'Unique', path:'#',symbol:<IoMdFingerPrint /> , description:'Lots of creative, remarkable adn greate landing, home and inner pages with their wonderful fascinating components'}, 
  ]

  export const featuresFaq = [
    {title:'Typescript Support', path:'#',symbol:<SiTypescript /> , description:'Aut labore veritatis magnam dicta quibusdam, temporibus eos impedit quam cum pariatur reprehenderit culpa'}, 
    {title:'Sass Style',  path:'#',symbol:<FaSass /> , description:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima suscipit eius adipisci aut quo vitae'}, 
    {title:'Bootstrap', path:'#',symbol:<SiBootstrap />, description:'Atque iure, ipsam qui recusandae. Amet eos quia rem laboriosam voluptate itaque voluptatem fugiat.'}, 
    {title:'Redux Toolkit', path:'#',symbol:<SiRedux /> , description:'Aut labore veritatis magnam dicta quibusdam, temporibus eos impedit quam cum pariatur reprehenderit culpa'}, 
    {title:'Darkmode',  path:'#',symbol:<MdOutlineDarkMode /> , description:'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minima suscipit eius adipisci aut quo vitae'}, 
    {title:'Framer Motion', path:'#',symbol:<SiFramer />, description:'Atque iure, ipsam qui recusandae. Amet eos quia rem laboriosam voluptate itaque voluptatem fugiat.'}, 
  
  ]

  export const questions = [
    {title:'1. What Nova is?', description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta mollitia illum qui aliquid eaque reiciendis ipsum iure explicabo omnis error repellat sunt dolor alias, pariatur quasi quo aspernatur necessitatibus provident.'},
    {title:'2. How I can find job', description:'Illo sint est blanditiis. Vel eaque nulla asperiores ipsa vitae aliquid ipsam rerum dolorem odio nesciunt atque quia sequi deserunt, deleniti a quos exercitationem neque maiores ullam vero totam? Sit perferendis quasi corrupti culpa.'},
    {title:'3. Which payment methods have', description:'Debitis numquam, eum qui architecto libero accusantium! Non est possimus dolorum repudiandae? Accusamus! Itaque nisi quibusdam ab eum adipisci delectus cum mollitia similique ratione deleniti commodi voluptatem, expedita dolorum debitis maxime vero consectetur, earum hic et dolore nam a. '},
  ]

  

  export const Accordions = ({data=questions}) => {

    return(
        <div className='accordions'>
            <ul>
                {data?.map((item,i)=>(
                    <Question key={`faq-${i}`} item={item} />
                ))}
            </ul>
        </div>
    )
}

const Question = ({item}) => {
    const [open, setOpen] = React.useState(false)
    return (
        <li>
            <div className='question' onClick={()=>setOpen(!open)}>
                <p>{item.title}</p>
                <div> {open ? <FiChevronDown size={19} /> : <FiChevronLeft size={19} />} </div>
            </div>
            {open && <p className="description">{item.description}</p> }
        </li>
    )
}


